// extracted by mini-css-extract-plugin
export var button = "_bj-4";
export var hasDarkBackground = "_bj-7";
export var hasLightBackground = "_bj-6";
export var iconWrapper = "_bj-0";
export var large = "_bj-2";
export var medium = "_bj-1";
export var small = "_bj-5";
export var xsmall = "_bj-3";